import type { SelectedSymbol } from '@/types/symbols';

export function isSameSymbol(a: SelectedSymbol, b: SelectedSymbol): boolean {
  return (
    a.Code === b.Code &&
    a.Period === b.Period &&
    a.PeriodType === b.PeriodType &&
    a.TimeRef === b.TimeRef
  );
}

// Forward-mode comparison: ignores Period in equality
export function isSameSymbolIgnoringPeriod(a: SelectedSymbol, b: SelectedSymbol): boolean {
  return a.Code === b.Code && a.PeriodType === b.PeriodType && a.TimeRef === b.TimeRef;
}

// Keep default export for backward-compatibility; defaults to full comparison
export default isSameSymbol;
